import React, { FunctionComponent } from 'react';
import { getImageUrl } from '../../../../utils/navigation';
import './BingoCardTall.scss';
import { BingoData } from '../BingoCard';
import { Heading } from '../../../shared/Heading';
import LazyLoadedImage from '../../../Media/LazyLoadedImage';

interface BingoCardTallProps {
  bingo: BingoData;
  onPlay: () => void;
}

export const BingoCardTall: FunctionComponent<BingoCardTallProps> = ({ bingo, onPlay }): JSX.Element => {
  const {
    title = 'Bingo Game Name',
    jackpot = '£00,00.00',
    prize = '£25',
    // min_bet = '£0.10',
    players = 0,
    number_of_balls = 90,
    img,
    roomID,
  } = bingo;

  const imageUrl = getImageUrl(img?.filename_disk);

  const handlePlay = (event: React.MouseEvent): void => {
    event.stopPropagation();

    if (roomID) {
      onPlay();
    }
  };

  return (
    <div className="bingo-card-tall">
      <div className="bingo-card-tall__image-container">
        {imageUrl ? (
          <LazyLoadedImage src={imageUrl} alt={title} className="bingo-card-tall__image" />
        ) : (
          <div className="bingo-card-tall__placeholder" />
        )}
      </div>
      <div className="bingo-card-tall__content">
        <div className="bingo-card-tall__header">
          <Heading className="bingo-card-tall__title" noMargin level={5}>
            {title}
          </Heading>
          <div className="bingo-card-tall__ball-count">{number_of_balls}</div>
        </div>

        <div className="bingo-card-tall__game-info">
          <div className="bingo-card-tall__money-info">
            {jackpot && <div className="bingo-card-tall__jackpot">Jackpot: {jackpot}</div>}
            {prize && <div className="bingo-card-tall__prize">Prize: {prize}</div>}
            {/* <div className="bingo-card-tall__bet-range">{min_bet}</div> */}
          </div>

          <div className="bingo-card-tall__right-section">
            {players && (
              <div className="bingo-card-tall__game-details">
                <div className="bingo-card-tall__players">👥 {players.toString().padStart(2, '0')}</div>
              </div>
            )}
            <button className="bingo-card-tall__play-btn" onClick={handlePlay}>
              {bingo.ctaText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
